import React, { FC } from 'react'
import { Box } from '@mui/material'
import { app } from 'config'
import { ErrorBoundary } from '../'

interface IProps {
  style?: any
  classNames?: string
  maxWidth?: string | string[]
  isNewLayout?: boolean
  children: any
}

const ModuleBody: FC<IProps> = ({
  style,
  classNames,
  maxWidth,
  isNewLayout,
  children,
}) => {
  const checkMaxWidth = () => {
    if (isNewLayout) {
      return 'inherit'
    } else {
      return maxWidth || app.layoutAndModuleWidth
    }
  }
  return children ? (
    <ErrorBoundary>
      <Box maxWidth={checkMaxWidth()} className={classNames} style={style}>
        {children}
      </Box>
    </ErrorBoundary>
  ) : null
}

export default ModuleBody
